import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_TYPE_SERVICES, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_TYPE_SERVICE,
  UPDATE_TYPE_SERVICE,
  DELETE_TYPE_SERVICE
 } from "./actionTypes";
import {
  getType_servicesSuccess,
  getType_servicesFail,
  addType_serviceSuccess,
  addType_serviceFail,
  updateType_serviceSuccess,
  updateType_serviceFail,
  deleteType_serviceSuccess,
  deleteType_serviceFail,
  // getType_servicesProfileSuccess,
  // getType_servicesProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getType_Services,
  // getType_servicesProfile,
  addNewType_Service,
  updateType_Service,
  deleteType_Service
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchType_services({payload : {vendor_type_id,is_active,offset,page_size}}) {
  try {
    const response = yield call(getType_Services,{vendor_type_id,is_active,offset,page_size});
    yield put(getType_servicesSuccess(response));
  } catch (error) {
    yield put(getType_servicesFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onUpdateType_services ({payload: ceremony }) {
  try {
    let response = yield call(updateType_Service, ceremony);
   if(response.file_src || ceremony.removeImage) ceremony.image = response.file_src

    yield put(updateType_serviceSuccess(ceremony));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(updateType_serviceFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onDeleteType_services({ payload: ceremony }) {
  
  try {
   const response =  yield call(deleteType_Service, ceremony);
    yield put(deleteType_serviceSuccess(ceremony));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(deleteType_serviceFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onAddNewType_services({ payload: ceremony }) {
  try {
    const response =  yield call(addNewType_Service, ceremony);
    yield put(addType_serviceSuccess(response.data));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(addType_serviceFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}


// function* fetchType_servicesProfile() {
//   try {
//     const response = yield call(getType_servicesProfile);
//     yield put(getType_servicesProfileSuccess(response));
//   } catch (error) {
//     yield put(getType_servicesProfileFail(error));
//   }
// }

function* ceremonysSaga() {
  yield takeEvery(GET_TYPE_SERVICES, fetchType_services);
  yield takeEvery(ADD_NEW_TYPE_SERVICE, onAddNewType_services);
  yield takeEvery(UPDATE_TYPE_SERVICE, onUpdateType_services);
  yield takeEvery(DELETE_TYPE_SERVICE, onDeleteType_services);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchType_servicesProfile);
}

export default ceremonysSaga;
